import { FulfillmentCutoffScheduleParser } from "@redotech/redo-conversion-settings-common/fulfillment-cutoff";
import * as z from "zod";

export const updateFulfillmentCutoffSchedule = {
  name: "updateFulfillmentCutoffSchedule" as const,
  input: z.object({ schedule: FulfillmentCutoffScheduleParser.nullable() }),
  output: z.null(),
};
